module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('Card', {
    staticClass: "no-shadow",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    }
  }, [_vm._l((_vm.categoryList), function(category) {
    return _c('a', {
      staticClass: "category",
      class: {
        'is-active': category.id == _vm.q && !_vm.k
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.filterNews(category.id)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  }), _vm._v(" "), _vm._l((_vm.newsCondition), function(item) {
    return _c('a', {
      staticClass: "category",
      class: {
        'is-active': item.key == _vm.k
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.filterNews(item.key)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "news-containter"
  }, [_vm._l((_vm.table.list), function(item) {
    return (_vm.table.total != 0) ? _c('div', {
      staticClass: "news-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "sundry"
    }, [(item.category) ? _c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.category ? item.category.data.name : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.inTimes))]), _vm._v(" "), _c('span', {
      staticClass: "browse"
    }, [_c('Icon', {
      attrs: {
        "type": "eye",
        "size": "14"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.browse_number))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('a', {
      staticClass: "read",
      attrs: {
        "href": '/news-content?q=' + item.id
      }
    }, [_vm._v("阅读全文")]), _vm._v(" "), _c('a', {
      staticClass: "mobile-btn",
      attrs: {
        "href": '/news-content?q=' + item.id
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.table.total == 0) ? _c('div', {
    staticClass: "no-more"
  }, [_vm._v("暂无相关新闻")]) : _vm._e()], 2), _vm._v(" "), _c('Page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.table.total != 0),
      expression: "table.total != 0"
    }],
    staticClass: "pagination",
    attrs: {
      "current": _vm.table.page,
      "total": _vm.table.total,
      "page-size": _vm.table.size,
      "size": "small"
    },
    on: {
      "on-change": _vm.handlePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92a19f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/news/news.vue
// module id = 658
// module chunks = 12